import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'
import Login from '@/components/Login'
import Projects from '@/components/project/Projects'
import Project from '@/components/project/Project'
import PageNotFound from '@/components/PageNotFound'
import Devices from '@/components/device/Devices'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: 'projects'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/projects/:id',
      name: 'project',
      component: Project,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/devices',
      name: 'devices',
      component: Devices,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/404',
      name: 'pageNotFound',
      component: PageNotFound
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

router.beforeResolve((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const pageNotFound = to.matched[0].path === '/404'

  if (requiresAuth && !currentUser) {
    next('login')
  } else if (!requiresAuth && currentUser && !pageNotFound) {
    next('projects')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js